import {DigitalDocumentTypeEnum} from '@/services/api-clients';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF';

const forceReceivedAllowedDigitalDocumentTypes = [DigitalDocumentTypeEnum.ReceivingProtocol, DigitalDocumentTypeEnum.BikeReceivingProtocol];

export function digitalDocumentTypeNameFilter(type: DigitalDocumentTypeEnum, isForcedReceive: boolean = false, item: string = ''): string {

  if (forceReceivedAllowedDigitalDocumentTypes.includes(type) && isForcedReceive) return i18n.t(LF.EmergencyReceive) as string;
  if (type === DigitalDocumentTypeEnum.GeneralProtocol && item !== '' && item !== null)return `${i18n.t(LF.GeneralProtocol) as string} - ${item}`;

  switch (type) {
    case DigitalDocumentTypeEnum.LeaseAgreement: return i18n.t(LF.LeaseAgreement) as string;
    case DigitalDocumentTypeEnum.LoanAgreement: return i18n.t(LF.LoanAgreement) as string;
    case DigitalDocumentTypeEnum.TransferProtocol: return i18n.t(LF.TransferProtocol) as string;
    case DigitalDocumentTypeEnum.ReceivingProtocol: return i18n.t(LF.ReceivingProtocol) as string;
    case DigitalDocumentTypeEnum.PromissoryNote: return i18n.t(LF.PromissoryNote) as string;
    case DigitalDocumentTypeEnum.DeclarationLackOfSII: return i18n.t(LF.DeclarationLackOfSII) as string;
    case DigitalDocumentTypeEnum.ContractOfMandateCourier: return i18n.t(LF.ContractOfMandateCourier) as string;
    case DigitalDocumentTypeEnum.ContractOfMandateDriver: return i18n.t(LF.ContractOfMandateDriver) as string;
    case DigitalDocumentTypeEnum.StudentStatusConfirmation: return i18n.t(LF.StudentStatusConfirmation) as string;
    case DigitalDocumentTypeEnum.BikeTransferProtocol: return i18n.t(LF.TransferProtocol) as string;
    case DigitalDocumentTypeEnum.BikeReceivingProtocol: return i18n.t(LF.ReceivingProtocol) as string;
    case DigitalDocumentTypeEnum.GeneralProtocol: return i18n.t(LF.GeneralProtocol) as string;
    case DigitalDocumentTypeEnum.CashRegisterReceipt: return i18n.t(LF.CashRegisterReceipt) as string;
    case DigitalDocumentTypeEnum.CashRegisterDisbursement: return i18n.t(LF.CashRegisterDisbursement) as string;
    default: return '';

  }
}
